import Box from '@mui/material/Box';
import React from 'react';

const ListSideComponent: React.FC<{
    children: React.ReactChild;
}> = ({ children }) => {
    if (!children) {
        return (
            <Box
                sx={{
                    textAlign: 'center',
                    padding: 2,
                    color: 'grey.600',
                    fontStyle: 'italic',
                    fontSize: '0.9rem'
                }}
            >
                אין נתונים
            </Box>
        );
    }

    return (
        <Box
            sx={{
                height: '100%',
                overflowY: 'auto',
                padding: '5px',
                '&::-webkit-scrollbar': {
                    display: 'none'
                },
                '&::-webkit-scrollbar-thumb': {
                    backgroundColor: 'grey.300',
                    borderRadius: '4px'
                },
                '&::-webkit-scrollbar-thumb:hover': {
                    backgroundColor: 'grey.500'
                }
            }}
        >
            {children}
        </Box>
    );
};

export default ListSideComponent;
